import {Auth} from "aws-amplify"
import {AppCenterApiName} from "services/constants"

const apiUrlWithoutVersion = process.env.GATSBY_API_URL?.replace(/\/v1\/?$/, "")

export const awsConfig = {
  Auth: {
    // (required) only for Federated Authentication - Amazon Cognito Identity Pool ID
    // identityPoolId: process.env.GATSBY_AWS_IDENTITY_POOL_ID,

    // (required)- Amazon Cognito Region
    region: process.env.GATSBY_AWS_REGION,

    // (optional) - Amazon Cognito Federated Identity Pool Region
    // Required only if it's different from Amazon Cognito Region
    // identityPoolRegion: "XX-XXXX-X",

    // (optional) - Amazon Cognito User Pool ID
    userPoolId: process.env.GATSBY_AWS_USER_POOL_ID,

    // (optional) - Amazon Cognito Web Client ID (26-char alphanumeric string, App client secret needs to be disabled)
    userPoolWebClientId: process.env.GATSBY_AWS_USER_POOL_WEB_CLIENT_ID,

    // (optional) - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: true,

    // (optional) - Configuration for cookie storage
    // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
    // cookieStorage: {
    //   // - Cookie domain (only required if cookieStorage is provided)
    //   domain: '.yourdomain.com',
    //   // (optional) - Cookie path
    //   path: '/',
    //   // (optional) - Cookie expiration in days
    //   expires: 365,
    //   // (optional) - See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
    //   sameSite: 'strict' | 'lax',
    //   // (optional) - Cookie secure flag
    //   // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
    //   secure: true
    // }

    // (optional) - customized cognito api endpoint (SignUp, ConfirmSignUp, etc.)
    endpoint: process.env.GATSBY_AWS_COGNITO_ENDPOINT,

    oauth: {
      domain: process.env.GATSBY_AWS_OATH_DOMAIN,
      scope: [
        // "aws.cognito.signin.user.admin",
        // "email",
        // "openid",
        // "phone",
        // "profile",
      ],
      redirectSignIn: process.env.GATSBY_AWS_OATH_REDIRECT_SIGNIN,
      redirectSignOut: process.env.GATSBY_AWS_OATH_REDIRECT_SIGNOUT,
      responseType: "code",
    },
  },
  API: {
    endpoints: [
      {
        name: AppCenterApiName.AppCenterApi,
        endpoint: process.env.GATSBY_API_URL,
        region: process.env.GATSBY_AWS_REGION,
        custom_header: () => ({"x-api-key": process.env.GATSBY_AWS_API_KEY}),
      },
      {
        name: AppCenterApiName.AppCenterApiWithToken,
        endpoint: process.env.GATSBY_API_URL,
        region: process.env.GATSBY_AWS_REGION,
        custom_header: async () => {
          return {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getAccessToken()
              .getJwtToken()}`,
          }
        },
      },
      {
        name: AppCenterApiName.AppCenterApiWithoutVersionWithIdToken,
        endpoint: apiUrlWithoutVersion,
        region: process.env.GATSBY_AWS_REGION,
        custom_header: async () => {
          return {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          }
        },
      },
    ],
  },
}
